module.exports = __webpack_public_path__ + "static/media/female.27be6fec.gif";